
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rental-policy",
      function () {
        return require("private-next-pages/rental-policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rental-policy"])
      });
    }
  